import React, { useContext } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import Checkbox from 'src/components/form-components/Checkbox/Checkbox';
import ValidationMessage from 'src/components/form-components/ValidationMessage/ValidationMessage';
import { AppContext } from 'src/contexts/AppContext';
import { BookingContext } from 'src/contexts/BookingFlowContext';
import { reservationEndFields } from 'src/services/validations/reservationEndRules';
import { ITermsCondidtionsProps } from '../../sections/StatementSection/StatementSection';

const messages = defineMessages({
    termsStatement: {
        id: 'termsStatement',
        defaultMessage: 'Elfogadom az <a>Általános Szerződési Feltételeket</a>.'
    }
})

const TermsConditionsStatement: React.FC<ITermsCondidtionsProps> = ({ validation, setTermsAccepted }) => {
    const { company } = useContext(AppContext);
    const { reservationEndUser } = useContext(BookingContext);

    return ((company?.TermsAndConditionsLink)
        ?
        <div className='reservation-end__statement'>
            <Checkbox
                checked={reservationEndUser.TermsAccepted ?? false}
                onChange={setTermsAccepted}
                required={true} >
                <FormattedMessage {...messages.termsStatement} 
                    values={{ a: (msg: any) => 
                    <a href={company.TermsAndConditionsLink} className='link' target='_blank' rel='noopener noreferrer'>
                        {msg}
                    </a> }} />
            </Checkbox>
            <ValidationMessage message={validation.fields[reservationEndFields.TermsAccepted]?.message} />
        </div>
        : 
        null
    );
}

export default TermsConditionsStatement;